import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M20.102,5.309v3.934h-5.819c-0.175,0-0.315,0.142-0.315,0.316V24h-3.935V9.559c0-0.174-0.142-0.316-0.315-0.316H3.898V5.309 h5.819c0.175,0,0.315-0.142,0.315-0.315V0h3.935v4.994c0,0.175,0.142,0.315,0.315,0.315H20.102z"
	})
});
export default SvgCross;
